import React, { useEffect, forwardRef, useState, useCallback, useMemo } from 'react';
import { CircularProgress, Grid, TextField, Select, InputLabel, MenuItem, Radio } from '@material-ui/core';
import MaterialTable from 'material-table';
import { useHistory } from 'react-router';
import { safeGet } from '../../axios-default';
import QueryString from 'querystring';
import Modal from '../../components/Modal/modal';
import DragAndDrop from '../../components/NewPatient/Photos/DragAndDrop';
import style from './PageBanner.module.css';
import axios from '../../axios-default';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { ApiServerUrl } from '../../config.json';
import { connect, useDispatch, useSelector } from 'react-redux';
import { easySnackbar } from '../../store/Noti/noti.actions';
import { updateRes } from '../../store/res/res.action';
import {
    Close as CloseIcon,
    Check as CheckIcon,
    AddBox,
    ArrowDownward,
    Check,
    ChevronLeft,
    ChevronRight,
    Clear,
    DeleteOutline,
    Edit,
    FilterList,
    FirstPage,
    LastPage,
    Remove,
    SaveAlt,
    Search,
    ViewColumn,
    StarRate,
} from '@material-ui/icons';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Edit as EditIcon, Add as AddIcon } from '@material-ui/icons';
const TableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const DistrMsgTable = ({ addOpen, handleAddModleOpen, handleAddButtonEnable }) => {
    const res = useSelector(({ res }) => res);
    const history = useHistory();
    const dispatch = useDispatch();

    const [data, setData] = useState([]),
        [loading, setLoading] = useState(true),
        [search, setSearch] = useState(''),
        [modalOpen, setModalOpen] = useState(false),
        [modalError, setModalError] = useState(''),
        [editModalOpen, setEditModalOpen] = useState(false),
        [selectedFile, setSelectedFile] = useState(false),
        //[updatedProductMatrix, setUpdatedProductMatrix] = useState({pmData: Object.assign({})})
        [updatedDistrMsg, setDistrMsg] = useState({ dmData: Object.assign({}) });

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => reject(error);
        });

    //useCallback( async file => {
    const handleSubmit = useCallback(async () => {
        try {
            var distr_group_id = JSON.parse(localStorage.getItem('distr_group_id'));
            if (distr_group_id === 'null') {
                distr_group_id = 0;
            }
            //this.setState({ PhotoUploadLoadingStatus: true, loading: true });
            let { data } = await axios.post(`distrmsg/create/${distr_group_id}`, updatedDistrMsg.dmData);
            if (!data.success) {
                dispatch(easySnackbar('Error. Please check your input.', 'error'));
                return;
            }

            dispatch(easySnackbar('Success', 'success'));
            setDistrMsg({ dmData: Object.assign({}) });
            reloadPage();
            setLoading(true);
            setModalOpen(false);
            reloadPage();
        } catch (err) {
            setSelectedFile(false);
            dispatch(easySnackbar('Error. Please check your input.', 'error'));

            console.error(err.response);
        } finally {
            //this.setState({ PhotoUploadLoadingStatus: false, loading: false });
            setLoading(false);
            setSelectedFile(false);
        }
    }, [updatedDistrMsg]);

    const handleEditSubmit = useCallback(async () => {
        try {
            //this.setState({ PhotoUploadLoadingStatus: true, loading: true });
            let { data } = await axios.post(`distrMsg/edit`, updatedDistrMsg.dmData);
            if (!data.success) {
                dispatch(easySnackbar('Error. Please check your input.', 'error'));
                return;
            }
            dispatch(easySnackbar('Success', 'success'));
            setDistrMsg({ dmData: Object.assign({}) });
            setLoading(true);
            setModalOpen(false);
            reloadPage();
        } catch (err) {
            //  this.setState({
            dispatch(easySnackbar('Error. Please check your input.', 'error'));
            //  modalError: "Something Went Wrong Please Connect With Admin",
            //  });
            console.error(err.response);
        } finally {
            //this.setState({ PhotoUploadLoadingStatus: false, loading: false });
            setLoading(false);
            setSelectedFile(false);
        }
    }, [updatedDistrMsg]);
    const handleUpdate = useCallback(
        (field) =>
            ({ target: { value } }) => {
                setDistrMsg({
                    ...updatedDistrMsg,
                    dmData: {
                        ...updatedDistrMsg.dmData,
                        [field]: value ?? null,
                    },
                });
            },
        [updatedDistrMsg, setDistrMsg]
    );

    const handleRadioUpdate = useCallback(
        (field) =>
            ({ target: { value } }) => {
                console.log(value);
                setDistrMsg({
                    ...updatedDistrMsg,
                    dmData: {
                        ...updatedDistrMsg.dmData,
                        [field]: value ?? null,
                    },
                });
            },
        [updatedDistrMsg, setDistrMsg]
    );

    const reloadPage = () => {
        const curPage = window.location.pathname;
        history.push('/blank');
        history.replace(curPage);
    };
    // const countrySelect = useMemo(() =>
    //   // Object.entries(res.countries).map(([id, c]) => (
    //   //   <MenuItem value={id} key={id}>{c.country_name}</MenuItem>
    //   // ))
    //   res.countries.map((c) => (
    //     <MenuItem value={c.country_id} key={c.country_id}>{c.country_name}</MenuItem>
    //   ))
    // , [res?.countries])

    const dataGetter = useCallback(
        async (query) => {
            await dispatch(updateRes('country'));
            const { pageSize, page: pageNo, search, orderBy, orderDirection } = query;
            let distr_group_id = JSON.parse(localStorage.getItem('distr_group_id'));

            if (distr_group_id === 'null') {
                distr_group_id = 0;
            }
            try {
                const { dm: data, total } = await safeGet(`/distrmsg/getdistrmsg`);
                if (total == 0) {
                    handleAddButtonEnable();
                }
                if (loading) setLoading(false);

                return {
                    data: data.filter(({ deleted_flag }) => !deleted_flag),
                    page: pageNo ?? 0,
                    totalCount: total ?? 0,
                };
            } catch (err) {
                console.error(err);
            }
        },
        [search]
    );

    return (
        <>
            <MaterialTable
                title="Distr Message List"
                data={dataGetter}
                actions={[
                    {
                        icon: () => <EditIcon />,
                        tooltip: 'Edit Row',

                        onClick: (_, data) => {
                            setDistrMsg({ dmData: Object.assign({}, data) });

                            setSelectedFile(false);
                            setEditModalOpen(true);
                        },
                    },
                ]}
                columns={[
                    {
                        field: 'id',
                        title: 'ID',
                        sorting: true,
                        filtering: true,
                    },
                    {
                        field: 'msg1',
                        title: 'message 1',
                        sorting: true,
                        filtering: true,
                    },
                    {
                        field: 'msg2',
                        title: 'message 2',
                        sorting: true,
                        filtering: true,
                    },
                    {
                        field: 'enable_flag',
                        title: 'Enable',
                        sorting: true,
                        filtering: true,
                    },
                    /*  `instagram` VARCHAR(200) NULL,
  `terms_conditions` VARCHAR(255) NULL,

        {
          field: 'image',
          title: 'Product Image',
          render:  rowData => (  <img style={{ width: "400px"}} src={ ApiServerUrl+ "file/config/" +rowData.product_image}/>) ,
          sorting: false,
          filtering: false,
        },
        {
          field: 'enable',
          title: 'Enable',
          sorting: true,
          filtering: true,
          render: rowData => (
            <div style={{ display: "flex", justifyContent: 'center', margin: '0px 4px', width: 40, height: 40 }}>
              {rowData.enable_flag ? <CheckIcon /> : <CloseIcon />}
            </div>
          )
        },
        */
                ]}
                options={{
                    initialPage: 0,
                    emptyRowsWhenPaging: false,
                    exportAllData: true,
                    debounceInterval: 700,
                    columnsButton: true,
                    pageSize: 10,
                    search: false,
                    pageSizeOptions: [10, 15, 30, 50, 100],
                    minBodyHeight: 700,
                    exportButton: true,
                }}
                icons={TableIcons}
                isLoading={loading}
            />
            <Modal
                className="modal"
                modal=""
                title="Add Distributor Message Before Doctor Approve Treatment Plan"
                open={addOpen}
                handleClose={() => {
                    handleAddModleOpen(false);

                    setSelectedFile(false);
                    setModalOpen(false);
                    setDistrMsg({ dmData: Object.assign({}) });
                }}
                handleDataSave={() => handleSubmit()}
                //modalError={this.modalError}
                submitButton={true}
            >
                <Grid item xs={12}></Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <TextField
                        fullWidth
                        label="Message 1"
                        variant="filled"
                        value={updatedDistrMsg.dmData ? updatedDistrMsg.dmData.msg1 : ''}
                        onChange={handleUpdate('msg1')}
                    />
                    <TextField
                        fullWidth
                        label="Message 2"
                        variant="filled"
                        value={updatedDistrMsg.dmData ? updatedDistrMsg.dmData.msg2 : ''}
                        onChange={handleUpdate('msg2')}
                    />
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">Enable</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={updatedDistrMsg.dmData ? updatedDistrMsg.dmData.enable_flag : 0}
                            name="radio-buttons-group"
                            onChange={handleRadioUpdate('enable_flag')}
                        >
                            <FormControlLabel value="1" control={<Radio />} label="Enable" />
                            <FormControlLabel value="0" control={<Radio />} label="Disable" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Modal>
            <Modal
                className="modal"
                modal=""
                title="Edit "
                open={editModalOpen}
                handleClose={() => {
                    setEditModalOpen(false);
                    setSelectedFile(false);
                    setDistrMsg({ dmData: Object.assign({}) });
                }}
                handleDataSave={() => handleEditSubmit()}
                //modalError={this.modalError}
                submitButton={true}
            >
                <Grid item xs={12} md={12} lg={12}>
                    <TextField
                        fullWidth
                        label="Message 1"
                        variant="filled"
                        value={updatedDistrMsg.dmData.msg1}
                        onChange={handleUpdate('msg1')}
                    />
                    <TextField
                        fullWidth
                        label="Message 2"
                        variant="filled"
                        value={updatedDistrMsg.dmData.msg2}
                        onChange={handleUpdate('msg2')}
                    />
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">
                            Enable{updatedDistrMsg.dmData.enable_flag ? '1' : '0'}
                        </FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={updatedDistrMsg.dmData.enable_flag ? '1' : '0'}
                            name="radio-buttons-group"
                            onChange={handleRadioUpdate('enable_flag')}
                        >
                            <FormControlLabel value="1" control={<Radio />} label="Enable" />
                            <FormControlLabel value="0" control={<Radio />} label="Disable" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Modal>
        </>
    );
};

export default DistrMsgTable;
